import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

import { TicketItem } from 'src/app/models';
import { TicketProvider } from 'src/app/providers';

@Component({
  selector: 'pos-open-text-modifier-modal',
  templateUrl: './open-text-modifier.modal.html',
  styleUrls: ['./open-text-modifier.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OpenTextModifierModal {
  @Input() selectedTicketItem: TicketItem;
  @Input() modifierColor: string | null = null;

  private readonly controls = {
    description: new FormControl(undefined, [
      Validators.required,
      Validators.maxLength(50)
    ]),
    price: new FormControl(undefined)
  };

  form = new FormGroup(this.controls);

  constructor(
    private modalController: ModalController,
    private ticketProvider: TicketProvider
  ) {}

  onSaveNotes() {
    const value = this.form.value;
    if (!value.price) {
      value.price = 0;
    }
    this.ticketProvider.ticketItemAddingHandler(
      <any>{
        name: value.description,
        price: value.price,
        modifier_color: this.modifierColor
      },
      this.selectedTicketItem.device_ticket_item_uuid
    );
    this.onCloseModal();
  }

  onCloseModal() {
    this.modalController.dismiss();
  }
}
